import { render, staticRenderFns } from "./sideInfo.vue?vue&type=template&id=76160964&scoped=true&"
import script from "./sideInfo.vue?vue&type=script&lang=js&"
export * from "./sideInfo.vue?vue&type=script&lang=js&"
import style0 from "./sideInfo.vue?vue&type=style&index=0&id=76160964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76160964",
  null
  
)

export default component.exports